import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material'

const TakeOffTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    placement='bottom-end'
    arrow
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#06004A',
    '&::before': {
      borderTopLeftRadius: '1px',
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#06004A',
    color: 'white',

    fontSize: '8px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    boxShadow: theme.shadows[1],
  },
  maxWidth: '225px',
}))

export default TakeOffTooltip
